import React from 'react';
import { StarRating } from './StarRating';

export const InstructorCard = ({ instructor }) => {
    return (
        <div className="bg-white border h-100 overflow-hidden">
            <img src={instructor.image} alt={instructor.name} className="img-fluid w-100 object-fit-cover" style={{ height: "170px" }} />
            <div className="item-info">
                <div className="text-center p-3">
                    <div className="instructor-name fs-6 mb-1">{instructor.name}</div>
                    <div className="instructor-role small text-secondary text-opacity-75">{instructor.role}</div>
                </div>

                <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 small text-body px-3 py-2">
                    <span className="ratings d-flex align-items-center gap-1">
                        <StarRating rating={instructor.rating} />
                        <span className="rating-number">{instructor.rating.toFixed(1)}</span>
                    </span>
                    <span>{instructor.students} <span className="text-secondary text-opacity-75">students</span></span>
                </div>
            </div>
        </div>
    )
}
